export default [
  {
    title: 'Dashboard',
    route: 'Dashboard',
    icon: 'HomeIcon',
  },
  {
    title: 'Building',
    route: 'building',
    icon: 'MapPinIcon',
  },
  {
    title: 'Device',
    route: 'device',
    icon: 'DatabaseIcon',
  },
  {
    title: 'History',
    route: 'history',
    icon: 'ClockIcon',
  },
]
